import { createFileRoute, Outlet } from "@tanstack/react-router";

const NotificationAnalyticsLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/notification-analytics")({
  component: NotificationAnalyticsLayout,
});
